module.exports = __webpack_public_path__ + "img/avisos.bb5acbe4.png";